export default [{
      "ID": 1002,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_hc.png",
      "Name": "火车票",
      "Desc": "火车票",
      "SortNo": 1
    }, {
      "ID": 1003,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_jp.png",
      "Name": "机票",
      "Desc": "国内/国际机票/分期机票/机场服务",
      "SortNo": 2
    }, {
      "ID": 1004,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_jiudian.png",
      "Name": "酒店",
      "Desc": "国内酒店/海外酒店/民宿/超值服务",
      "SortNo": 3
    }, {
      "ID": 1005,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_qc.png",
      "Name": "汽车票",
      "Desc": "汽车票/城际快车",
      "SortNo": 4
    }, {
      "ID": 1006,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_yc.png",
      "Name": "用车",
      "Desc": "国内/国际用车/租车/中转联运",
      "SortNo": 5
    }, {
      "ID": 1007,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_jd.png",
      "Name": "景区",
      "Desc": "景区门票/景区直通车",
      "SortNo": 6
    }, {
      "ID": 1008,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_yl.png",
      "Name": "船票",
      "Desc": "船票/邮轮",
      "SortNo": 7
    }, {
      "ID": 1009,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_dj.png",
      "Name": "旅游度假",
      "Desc": "国内/周边/出境游/自由行/签证",
      "SortNo": 8
    }, {
      "ID": 1010,
      "Icon": "//file.40017.cn/tcservice/wxapp/h5/image/assets/icon_qt.png",
      "Name": "其他订单",
      "Desc": "保险",
      "SortNo": 9
    }]


// WEBPACK FOOTER //
// ./src/util/productIds.js